/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const Ingredient_URL = `${API_URL}`;

const updateIngredient = async (id: any, updatedData: any) => {
  const res = await axios.put(`${Ingredient_URL}update-ingredient/${id}`, updatedData, getToken());
  return res.data;
};

const deleteIngredient = async (id: any) => {
  const response = await axios.put(`${Ingredient_URL}delete-ingredient/${id}`);
  return response.data;
};

const viewIngredientById = async (id: any) => {
  const response = await axios.get(`${Ingredient_URL}view-ingredient/${id}`, getToken());
  return response.data;
};

const findDuplicateIngredient = async (name: any) => {
    const response = await axios.post( `${API_URL}find-duplicate-ingredient`,  { name }, getToken()  );
  return response.data;
};

export {
  updateIngredient,
  deleteIngredient,
  viewIngredientById,
  findDuplicateIngredient,
};
